import { render } from "./App.vue?vue&type=template&id=084a8afc&bindings={\"puzzleData\":\"data\",\"loaded\":\"data\",\"loading\":\"data\",\"uploadWait\":\"data\",\"getPuzzleData\":\"options\",\"processFile\":\"options\",\"processJson\":\"options\",\"processPuz\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
script.render = render

export default script